
(() => {
  if (window.poltzaaCartConfettiInitialized) return;
  window.poltzaaCartConfettiInitialized = true;

  const rewardSelector = '.poltzaa-rewards__milestone.is-unlocked';
  const storageKey = 'poltzaa-seen-rewards-v3';

  let previousRewards = new Set();
  let lastOpenState = false;
  let animationTimer;

  try {
    previousRewards = new Set(
      JSON.parse(sessionStorage.getItem(storageKey) || '[]')
    );
  } catch (error) {}

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isDrawerOpen(drawer) {
    return !!drawer && (
      drawer.classList.contains('active') ||
      drawer.classList.contains('animate')
    );
  }

  function launchConfetti(intensity = 1) {
    const drawer = getDrawer();
    if (!drawer) return;

    const confettiLayer = drawer.querySelector('#CartDrawer');
    if (!confettiLayer) return;

    // Remove any previous confetti animation.
    confettiLayer
      .querySelectorAll('.poltzaa-confetti')
      .forEach((element) => element.remove());

    const container = document.createElement('div');
    container.className = 'poltzaa-confetti';
    container.setAttribute('aria-hidden', 'true');

    const colors = [
      '#47745e',
      '#f2c6d4',
      '#d7b16d',
      '#9b7bd3',
      '#f08b68',
      '#73b8c6'
    ];

    const count = intensity >= 3 ? 90 : intensity === 2 ? 65 : 45;

    for (let i = 0; i < count; i++) {
      const piece = document.createElement('span');
      piece.className = 'poltzaa-confetti__piece';

      piece.style.left = `${Math.random() * 100}%`;
      piece.style.backgroundColor =
        colors[Math.floor(Math.random() * colors.length)];

      piece.style.setProperty(
        '--fall-duration',
        `${2.2 + Math.random() * 2}s`
      );

      piece.style.setProperty(
        '--fall-delay',
        `${Math.random() * 0.65}s`
      );

      piece.style.setProperty(
        '--drift',
        `${Math.random() * 140 - 70}px`
      );

      piece.style.setProperty(
        '--spin',
        `${Math.random() * 900 - 450}deg`
      );

      piece.style.width = `${5 + Math.random() * 5}px`;
      piece.style.height = `${8 + Math.random() * 7}px`;

      container.appendChild(piece);
    }

    confettiLayer.appendChild(container);

    window.clearTimeout(animationTimer);

    animationTimer = window.setTimeout(() => {
      container.remove();
    }, 5200);
  }

  function checkRewards() {
    const drawer = getDrawer();

    if (!drawer || !isDrawerOpen(drawer)) return;

    // Read the milestones that are unlocked RIGHT NOW.
    const currentRewards = new Set(
      [...drawer.querySelectorAll(rewardSelector)]
        .map((element) => element.dataset.rewardId)
        .filter(Boolean)
    );

    // Detect rewards that changed from locked to unlocked.
    const newlyUnlocked = [...currentRewards].filter(
      (reward) => !previousRewards.has(reward)
    );

    if (newlyUnlocked.length > 0) {
      const intensity = Math.max(
        ...newlyUnlocked.map((reward) =>
          reward === 'discount-15' ? 3 :
          reward === 'free-charm' ? 2 : 1
        )
      );

      launchConfetti(intensity);
    }

    // IMPORTANT:
    // Replace the previous state instead of only adding to it.
    // Locked milestones are therefore eligible to celebrate again.
    previousRewards = currentRewards;

    try {
      sessionStorage.setItem(
        storageKey,
        JSON.stringify([...previousRewards])
      );
    } catch (error) {}
  }

  function watchDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;

    const open = isDrawerOpen(drawer);

    if (open && !lastOpenState) {
      // Allow Dawn to finish rendering the cart first.
      window.setTimeout(checkRewards, 300);
    }

    lastOpenState = open;
  }

  let checkTimer;

  function scheduleRewardCheck() {
    window.clearTimeout(checkTimer);

    // Wait for Dawn's cart HTML to finish updating.
    checkTimer = window.setTimeout(() => {
      watchDrawer();
      checkRewards();
    }, 200);
  }

  const observer = new MutationObserver(() => {
    watchDrawer();
    scheduleRewardCheck();
  });

  function start() {
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    watchDrawer();
    scheduleRewardCheck();
  }

  // Also check after quantity changes, removals and upsell additions.
  document.addEventListener('click', (event) => {
    if (
      event.target.closest(
        'cart-drawer .quantity__button, ' +
        'cart-drawer cart-remove-button, ' +
        'cart-drawer [data-poltzaa-upsell-add]'
      )
    ) {
      window.setTimeout(scheduleRewardCheck, 500);
    }
  });

  document.addEventListener('change', (event) => {
    if (
      event.target.matches(
        'cart-drawer .quantity__input'
      )
    ) {
      window.setTimeout(scheduleRewardCheck, 500);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  } else {
    start();
  }
})();
